import createActions from 'src/replicant/config/actions/createActions';
import { action } from '@play-co/replicant';
import * as Match2 from 'src/replicant/match2';
import { getMatch2FrenzyIntroTimestampKey } from 'src/replicant/match2/match2.ruleset';
import { getTimedRewardUserProperties } from 'src/replicant/match2/match2.analytics';
import { setMatch2Timestamp } from 'src/replicant/match2/match2.modifiers';
import * as match2FrenzyModifiers from './match2-frenzy.modifiers';
import {
  getMatch2FrenzyEventConfig,
  getMatch2FrenzyMilestoneReward,
  getMatch2UnclaimedFrenzyMilestoneRewards,
} from './match2-frenzy.getters';
import { processMatch2Rewards } from '../rewards/match2-rewards.getters';
import {
  Match2Reward,
  isNestedReward,
  isTimedReward,
} from '../rewards/match2-rewards.ruleset';
import { sendAnalyticsEvents } from 'src/replicant/analytics';

export const match2FrenzyActions = createActions({
  resetMatch2Frenzy: action((state, _, api) => {
    match2FrenzyModifiers.resetFrenzy(state, api.date.now(), true);
  }),

  claimMatch2FrenzyRewards: action((state, timestamp: number, api) => {
    const now = api.date.now();
    const config = getMatch2FrenzyEventConfig(state, now);

    if (!config) return;
    state.match2.frenzy.unclaimedMilestone.forEach((level) => {
      const reward = getMatch2FrenzyMilestoneReward(state, now, level)!;

      // Send analytics event.
      sendAnalyticsEvents(api, [
        {
          eventType: 'FrenzyLevelRewardClaimed',
          eventProperties: {
            gameType: 'match2', // to distinguish from slots frenzy
            eventID: config.id,
            frenzyLevel: level,
            rewardType: reward.type,
            rewardSubType: 'subType' in reward ? reward?.subType : undefined,
            rewardAmount: 'amount' in reward ? reward?.amount : undefined,
            rewardDuration: isTimedReward(reward)
              ? reward?.duration
              : undefined,
            bundleType:
              isNestedReward(reward) && reward.decoration
                ? reward.decoration.type === 'chest'
                  ? 'chest'
                  : 'powerup_combo'
                : undefined,
          },
        },
      ]);
    });

    const rawRewards = getMatch2UnclaimedFrenzyMilestoneRewards(state, now);
    if (!rawRewards.length) return;
    const rewards = processMatch2Rewards(rawRewards, timestamp);
    state.match2.frenzy.unclaimedMilestone.length = 0;

    Match2.modifiers.grantMatch2Rewards(
      state,
      rewards,
      { feature: 'match_frenzy_rewards_claimed' },
      api,
      { userProperties: getTimedRewardUserProperties(state, api.date.now()) },
    );
  }),

  setMatch2FrenzyIntroTimestamp: action((state, _: void, api) => {
    setMatch2Timestamp(
      state,
      getMatch2FrenzyIntroTimestampKey(),
      api.date.now(),
    );
  }),
});
